export function createConversationListQuery(repository) {
    return {
        invalidateOn: ["domain.entity-changed", "sync.delta-applied"],
        key: (row) => row.id,
        name: "conversation.list.v1",
        run: async (params) => await repository.listConversations(parseConversationListParams(params)),
    };
}
export function createConversationMessagesQuery(repository) {
    return {
        invalidateOn: ["domain.entity-changed", "sync.delta-applied"],
        key: (row) => row.id,
        name: "conversation.messages.v1",
        run: async (params) => {
            const parsed = parseConversationMessagesParams(params);
            return await repository.listMessages(parsed.conversationId, parsed);
        },
    };
}
export function parseConversationListParams(value) {
    const record = exactRecord(value, ["before", "limit"], "conversation list");
    return { ...optionalBefore(record.before, "conversation list"), ...optionalLimit(record.limit, "conversation list") };
}
export function parseConversationMessagesParams(value) {
    const record = exactRecord(value, ["before", "conversationId", "limit"], "conversation messages");
    if (typeof record.conversationId !== "string" || record.conversationId.trim() === "")
        throw invalid("conversation messages");
    return {
        conversationId: record.conversationId,
        ...optionalBefore(record.before, "conversation messages"),
        ...optionalLimit(record.limit, "conversation messages"),
    };
}
function exactRecord(value, allowed, label) {
    if (value === null || typeof value !== "object" || Array.isArray(value))
        throw invalid(label);
    const record = value;
    if (Object.keys(record).some((key) => !allowed.includes(key)))
        throw invalid(label);
    return record;
}
function optionalBefore(value, label) {
    if (value === undefined)
        return {};
    if (typeof value !== "string" || value.trim() === "")
        throw invalid(label);
    return { before: value };
}
function optionalLimit(value, label) {
    if (value === undefined)
        return {};
    if (typeof value !== "number" || !Number.isInteger(value) || value < 1 || value > 100)
        throw invalid(label);
    return { limit: value };
}
function invalid(label) {
    return new TypeError(`Invalid ${label} query parameters`);
}
//# sourceMappingURL=conversations.js.map